// Edits `location_settings_input`, the one attribute whose value *is* a schema: it
// authors the fields that later appear on the Location Settings screen.

import { useMemo, useRef } from 'react';

const EMPTY_ATTRIBUTE = {
  attribute_name: '',
  description: '',
  html_tag: 'text_input',
  required: false,
};

const asList = (value) => (Array.isArray(value) ? value : []);

// Handlers must keep one identity: the renderer builds its field component from
// them, and a new identity per keystroke remounts the rows and drops focus.
export default function useLocationSettingsAttributes({ values, setValue }) {
  const valuesRef = useRef(values);
  valuesRef.current = values;

  return useMemo(
    () => ({
      addEntry: ({ fieldName }) => {
        setValue(fieldName, [
          ...asList(valuesRef.current[fieldName]),
          { ...EMPTY_ATTRIBUTE },
        ]);
      },
      changeValue: ({ e, item, index, fieldName, field, selectedId }) => {
        const current = [...asList(valuesRef.current[fieldName])];

        if (field === 'html_tag') {
          current[index] = { ...item, html_tag: selectedId };
        } else {
          const { value, name, checked } = e.target;

          switch (name.split('-')[0]) {
            case 'attribute_name':
              current[index] = { ...item, attribute_name: value };
              break;
            case 'description':
              current[index] = { ...item, description: value };
              break;
            case 'required':
              current[index] = { ...item, required: checked };
              break;
            default:
              return;
          }
        }

        setValue(fieldName, current);
      },
      removeEntry: (index, fieldName) => {
        const current = [...asList(valuesRef.current[fieldName])];
        current.splice(index, 1);
        setValue(fieldName, current);
      },
    }),
    [setValue],
  );
}
